import crawlApi, {
  type CrawlCountArg,
  type CrawlRequestBody
} from './crawlApi';

const internalLinksApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    countCrawlInternalLinks: build.query<unknown, CrawlCountArg>({
      query: ({ job_page, domain_slug }: CrawlCountArg) => ({
        url: '/khazesh/v3/internal_links/count',
        method: 'POST',
        body: { job_page, domain_slug }
      })
    }),

    getCrawlInternalLinks: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/internal_links/`,
        method: 'POST',
        body: body
      })
    })
  })
});

export const {
  useCountCrawlInternalLinksQuery,
  useGetCrawlInternalLinksMutation
} = internalLinksApi;
export default internalLinksApi;
